import { Observable } from 'rxjs';
import { filter, map, pairwise, startWith } from 'rxjs/operators';
import {
  BREAKPOINT_CONFIG,
  BREAKPOINT_DEFINITION,
  KEYS,
} from '../constants/breakpoints.const';
import Breakpoint from './../entities/breakpoint.entity';
import ResizeService from './resize.service';
import { WindowDimensions } from './viewport.service';

const Breakpoints: Breakpoint[] = [];

function register(key: string, min: number, max: number): void {
  const breakPoint = new Breakpoint(key, min, max);
  Breakpoints.push(breakPoint);
}

function setupBreakpoints(styleConfig: any): void {
  const breakPointDefinition = styleConfig[BREAKPOINT_DEFINITION];

  for (const alias in breakPointDefinition) {
    if (breakPointDefinition.hasOwnProperty(alias)) {
      register(
        breakPointDefinition[alias][KEYS.NAME],
        breakPointDefinition[alias][KEYS.MIN],
        breakPointDefinition[alias][KEYS.MAX]
      );
    }
  }
}

function isInRange(breakPoint: Breakpoint, width: number): boolean {
  return breakPoint.min <= width && breakPoint.max >= width;
}

function calcBreakpoint(width: number): Breakpoint | undefined {
  return Breakpoints.find((breakPoint) => isInRange(breakPoint, width));
}

function detectBreakpointChange(events: WindowDimensions[]): boolean {
  return calcBreakpoint(events[0].width) !== calcBreakpoint(events[1].width);
}

function getCurrentBreakpoint(
  events: { width: number }[]
): Breakpoint | undefined {
  return calcBreakpoint(events[1].width);
}

function registerBreakpointEvent(): Observable<Breakpoint | undefined> {
  return ResizeService.resizeEvent.pipe(
    startWith(ResizeService.getCurrent()),
    pairwise(),
    filter((wd) => detectBreakpointChange(wd)),
    map(getCurrentBreakpoint)
  );
}

if (Breakpoints.length == 0) {
  setupBreakpoints(BREAKPOINT_CONFIG);
}

const BreakpointService = {
  use: setupBreakpoints,
  breakpointEvent: registerBreakpointEvent(),
  getBreakpoints: (): Breakpoint[] => {
    return Breakpoints;
  },
};

export default BreakpointService;
